module.exports = __webpack_public_path__ + "img/phone.b355a2b8.svg";